import React from 'react';
const JsonLd = (props) => {
    const { children, location, pageContext, data, globalData } = props;
    if (data && pageContext?.originalId && Object.entries(data).find(([a, b]) => b.jsonLd)?.[1]?.jsonLd) {
        const json = Object.entries(data).find(([a, b]) => b.jsonLd)?.[1]?.jsonLd;
        if (typeof json === "string") {
            return (React.createElement("script", { type: "application/ld+json", dangerouslySetInnerHTML: { __html: json } }));
        }
        return null;
    }
    if (pageContext.originalId) {
        // Is Dato but missing jsonLd, throw
        throw new Error(`Data on this page is derived from Dato, but the 'jsonLd' field has not been included on the template's query. Please add it.`);
    }
    return null;
};
export default JsonLd;
//# sourceMappingURL=index.js.map